/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import { GetHelperErrorsResponse } from '../types';

export class Helper extends Controller {
  async getHelperErrors<T extends GetHelperErrorsResponse, D, C>(
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      '/helper/errors',
      axiosConfig
    );
  }
}
